import * as React from "react";
import FormControl from "components/Forms/FormControl";
import Form, { FormComponentProps } from "antd/lib/form";
import ValidationUtility from "Core/ValidationUtility";
import FormUtility from "Core/FormUtility";
import { Select } from "antd";
import { WrappedFormUtils } from "antd/lib/form/Form";

export interface Props {
    children?: React.ReactNode;
    intialValue: string;
    countryCode: string;
    formDecorator: any
}

export interface State {
}

export default class TerritorySelector extends React.Component<Props, State> {

    constructor(props: Props) {
        super(props)
        this.setTerritory = this.setTerritory.bind(this);

        this.state = {
        }
    }

    componentDidMount() {
        this.setState({})

        this.setTerritory();
        console.log(this.props.countryCode)
    }
    componentDidUpdate() {
        // this.setTerritory();
    }

    setTerritory = () => {
        const { Option } = Select;
        let validatorMessage;
        let UpdateValueName;
        let RegistrationValueName;
        let selectorType;
        let labelName;
        const { countryCode } = this.props


        //assign values based country code
        if (countryCode === 'US') {
            validatorMessage = 'Please select a State';
            UpdateValueName = 'stateCode';
            RegistrationValueName = 'cardDetails.billingAddress.stateCode';
            selectorType = FormUtility.stateSelector();
            labelName = 'State';
        }
        else if (countryCode === 'CA') {
            validatorMessage = 'Please select a Province';
            UpdateValueName = 'stateCode';
            RegistrationValueName = 'cardDetails.billingAddress.stateCode';
            selectorType = FormUtility.provinceSelector();
            labelName = 'Province';
        }
        else if (countryCode === 'JM') {
            validatorMessage = 'Please select a Parish';
            UpdateValueName = 'province';
            RegistrationValueName = 'cardDetails.billingAddress.province';
            selectorType = FormUtility.parishSelector();
            labelName = 'Parish';
        }
        else {
            validatorMessage = 'Please select a Territory';
            UpdateValueName = 'province';
            RegistrationValueName = 'cardDetails.billingAddress.province';
            selectorType = <Select mode="tags" maxTagCount={1} allowClear={true}>
                <Option value={this.props.intialValue}>{this.props.intialValue}</Option>
            </Select>
            labelName = 'Territory';
        }

        return <FormControl
            getFieldDecorator={this.props.formDecorator}
            rules={[...ValidationUtility.getRequired(validatorMessage)]}
            name={this.props.intialValue === '' ? RegistrationValueName : UpdateValueName}
            initialValue={this.props.intialValue}
            label={labelName}
        >
            {selectorType}
        </FormControl>
    }

    render() {
        return (
            <>{this.setTerritory()}</>
        )
    }
}